import type { DigitalMenuQr, DigitalMenuSettings, DigitalMenuSettingsPatch } from 'shared-models';
import { authenticatedInstance } from '../index/index.service';

const path = (tenantId: string) => `/digital-menu/tenant/${encodeURIComponent(tenantId)}`;
const session = (employeeSession: string) => ({ headers: { 'x-employee-session': employeeSession } });
export const DIGITAL_MENU_UPDATE = 'digital-menu-settings-update';
export function deliverDigitalMenuSettings(tenantId: string, settings: DigitalMenuSettings) {
  window.dispatchEvent(new CustomEvent(DIGITAL_MENU_UPDATE, { detail: { tenantId, settings } }));
}

export const digitalMenuManagementService = {
  async adminSettings(tenantId: string): Promise<DigitalMenuSettings> {
    return (await authenticatedInstance.get<DigitalMenuSettings>(`${path(tenantId)}/entitlement`)).data;
  },
  async qr(tenantId: string, employeeSession: string): Promise<DigitalMenuQr> {
    return (await authenticatedInstance.get<DigitalMenuQr>(`${path(tenantId)}/qr`, session(employeeSession))).data;
  },
  async pdf(tenantId: string, employeeSession: string): Promise<Blob> {
    return (await authenticatedInstance.get<Blob>(`${path(tenantId)}/qr.pdf`, { ...session(employeeSession), responseType: 'blob' })).data;
  },
  async email(tenantId: string, employeeSession: string, email: string): Promise<void> {
    await authenticatedInstance.post(`${path(tenantId)}/qr/email`, { email }, session(employeeSession));
  },
  async image(tenantId: string, employeeSession: string, file: File | null): Promise<void> {
    if (file) {
      const body = new FormData(); body.append('file', file);
      await authenticatedInstance.post(`${path(tenantId)}/atmosphere`, body, session(employeeSession));
    } else await authenticatedInstance.delete(`${path(tenantId)}/atmosphere`, session(employeeSession));
  },
  async settings(tenantId: string, employeeSession: string): Promise<DigitalMenuSettings> {
    return (await authenticatedInstance.get<DigitalMenuSettings>(`${path(tenantId)}/settings`, session(employeeSession))).data;
  },
  async save(tenantId: string, employeeSession: string, patch: DigitalMenuSettingsPatch): Promise<void> {
    if (Object.keys(patch).length === 0) return;
    await authenticatedInstance.patch(`${path(tenantId)}/settings`, patch, session(employeeSession));
  },
  async entitlement(tenantId: string, enabled: boolean): Promise<void> {
    await authenticatedInstance.patch(`${path(tenantId)}/entitlement`, { isDigitalMenu: enabled });
  },
};